var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.processing)?_c('loader'):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }